import React, { useState } from "react";
import { Box } from "@mui/material";
import Text from "./text/Text";
import ErrorIcon from "@mui/icons-material/Error";
import { CustomPopper } from "./popper/Popper";
import {
  networkFee,
  onChainFeesMsg,
  rateChangeMsg,
  sats,
  swap,
  totalAmount,
} from "./messages";

function QrInfoBox({ infoData, isFrom, isFromBrowser, currency }) {
  const [anchorEl, setAnchorEl] = useState({});
  const textSize = isFromBrowser ? 16 : 14;

  const handleAnchor = (e, index) => {
    setAnchorEl((prev) => ({
      ...prev,
      [index]: prev[index] ? null : e.currentTarget,
    }));
  };

  const handleCloseAnchor = (e, index) => {
    setAnchorEl({ ...anchorEl, [index]: null });
  };

  return (
    <Box className="qr-info-box">
      {infoData.map((data, index) => {
        const isTotalAmountFromSwap =
          data?.label === totalAmount && isFrom === swap;
        return (
          <Box className="qr-info" key={index}>
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center">
                <Text
                  className={
                    isTotalAmountFromSwap ? "default-text" : "grey-text"
                  }
                  font={isTotalAmountFromSwap ? "semibold" : "regular"}
                  size={textSize}
                >
                  {data?.label}
                </Text>
                {data?.showInfo && (
                  <>
                    <ErrorIcon
                      aria-describedby={"account-fee"}
                      sx={{
                        height: "18px",
                        width: "18px",
                        color: "#A4A9B7 !important",
                        marginLeft: "4px !important",
                      }}
                      onClick={(e) => handleAnchor(e, index)}
                    />
                    <CustomPopper
                      id="account-fee"
                      disablePortal={true}
                      open={anchorEl[index]}
                      anchorEl={anchorEl[index]}
                      position="top"
                      handleClose={(e) => handleCloseAnchor(e, index)}
                      sx={{ width: isFromBrowser ? "332px" : "253px" }}
                    >
                      <Text variant="inherit" font="regular" size={textSize}>
                        {data?.infoMsg}
                      </Text>
                    </CustomPopper>
                  </>
                )}
              </Box>
              {isFrom === "receive" ? (
                data?.value
              ) : (
                <Text className="default-text" font="semibold" size={14}>
                  {data?.value}
                </Text>
              )}
            </Box>
            {data?.label === networkFee && currency === sats && (
              <Text
                size={textSize}
                font="regular"
                sx={{ color: "#D88A2C", marginTop: "8px" }}
              >
                {onChainFeesMsg}
              </Text>
            )}
            {isTotalAmountFromSwap && (
              <Text
                className="grey-text"
                font="regular"
                size={textSize}
                variant="subtitle1"
                sx={{ marginTop: "8px" }}
              >
                {rateChangeMsg}
              </Text>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

export default QrInfoBox;
